import type * as BasketUpdated from '@ori-events/basket-updated';

import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';

export async function clearBasketHandler() {
  const response = await fetch(RequestUrl.ClearBasket, getHttpRequestSettings());

  return convertToCamelCase<BasketUpdated.Data>((await response.json()) as object);
}
